import { useQuery } from '@tanstack/react-query';
import { api } from '../api/http';

interface FeaturesResponse {
  enabled: string[];
  known: string[];
  mode: 'strict' | 'legacy_all_on';
}

function useFeaturesData() {
  return useQuery({
    queryKey: ['features'],
    queryFn: () => api.get<FeaturesResponse>('/features').then(r => r.data),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

export function useFeatureEnabled(flag: string): boolean {
  const { data } = useFeaturesData();
  if (!data) return false;
  if (data.mode === 'legacy_all_on') return true;
  const enabled = Array.isArray(data.enabled) ? data.enabled : [];
  return enabled.includes(flag);
}
